export enum StatusState {
	ELABORE = 'Élaboré',
	ENVOYE = 'Envoyé',
	PUBLIE = 'Publié',
	REFUSE = 'Refusé',
	EN_ATTENTE = 'En attente',
	ANNULE = 'Annulé',
	REJETE = 'Rejeté',
}
